// typed.js scrive e cancella il placeholder in loop infinito: main thread che
// non smette mai, su una pagina dove il campo puo' anche non vedersi.
// Qui la libreria si scarica solo quando il campo entra davvero nel viewport,
// e l'animazione parte a processore libero.
//
// Un elemento in display:none non interseca mai: e' esattamente il
// comportamento voluto per il campo dentro il menu mobile chiuso.

const options = {
    strings: [
        "Cerca su Frav.it",
        "Cerca la tua Audi",
        "Cerca la tua Porsche",
        "Cerca Audi usate",
        "Cerca Audi nuove",
        "Cerca Audi km 0",
        "Cerca Sportback",
    ],
    typeSpeed: 90,
    backSpeed: 60,
    attr: "placeholder",
    smartBackspace: true,
    bindInputFocusEvents: true,
    loop: true,
};

const whenIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));

function startTyped(element) {
    whenIdle(() => {
        import("typed.js").then(({ default: Typed }) => new Typed(element, options));
    });
}

function startWhenVisible(element) {
    if (!element) {
        return;
    }

    if (!("IntersectionObserver" in window)) {
        startTyped(element);
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                startTyped(entry.target);
            }
        });
    });

    observer.observe(element);
}

startWhenVisible(document.getElementById("searchtext"));
startWhenVisible(document.getElementById("searchtextmobile"));
